import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon width="24px" height="11px" viewBox="0 0 24 11" {...props}>
      <title>{props.title || 'Arrow'}</title>
      <g>
        <g transform="translate(-1461.000000, -657.000000)" fill="#6CA12B">
          <g transform="translate(110.000000, 610.000000)">
            <path d="M1372.9283,52.5899501 C1372.93611,52.54366 1372.94227,52.4965282 1372.94227,52.4477132 C1372.94227,52.438876 1372.9398,52.4308805 1372.9398,52.4220433 L1373.01582,52.5003156 L1372.9283,52.5899501 Z M1374.75922,51.9052775 L1370.21068,47.2468104 C1369.89019,46.9177299 1369.36918,46.9177299 1369.04869,47.2468104 C1368.72779,47.5750493 1368.72779,48.108227 1369.04869,48.4368867 L1372.14556,51.6086 C1372.13693,51.6081792 1372.12912,51.6060751 1372.12049,51.6060751 L1351.82178,51.6060751 C1351.36816,51.6060751 1351,51.983129 1351,52.4477132 C1351,52.9127183 1351.36816,53.2893514 1351.82178,53.2893514 L1372.12049,53.2893514 C1372.16816,53.2893514 1372.21418,53.2830391 1372.25937,53.2750435 L1369.04869,56.5633237 C1368.72779,56.8919834 1368.72779,57.4247403 1369.04869,57.7534 C1369.20935,57.9179403 1369.41931,58 1369.62969,58 C1369.84006,58 1370.05044,57.9179403 1370.21068,57.7534 L1374.75922,53.0953538 C1374.9133,52.9375466 1375,52.7233497 1375,52.5003156 C1375,52.2768607 1374.9133,52.0630846 1374.75922,51.9052775 L1374.75922,51.9052775 Z" />
          </g>
        </g>
      </g>
    </Icon>
  )
}
